const RenderReadsFilteringCharts = (csv, runid, camera, type) => {
    try {
        if (type === 'h5') {
            let updatedCSV = {};
            if (csv.barcodes.length > 25) {
                for (const key in csv) {
                    if (Array.isArray(csv[key])) {
                        updatedCSV[key] = csv[key].slice(0, 25);
                    }
                }
            }
            else updatedCSV = csv;

            let trace1 = {
                x: updatedCSV.barcodes,
                y: updatedCSV.passed_rsq.map(m => m.toFixed(2)),
                name: 'passed RSQ',
                type: 'bar',
                text: updatedCSV.passed_rsq.map(m => m.toFixed(2)).map(String),
                textposition: 'auto',
            };

            let trace2 = {
                x: updatedCSV.barcodes,
                y: updatedCSV.failed_rsq.map(m => m.toFixed(2)),
                name: 'failed RSQ',
                type: 'bar',
                text: updatedCSV.failed_rsq.map(m => m.toFixed(2)).map(String),
                textposition: 'auto',
            };

            const data = [trace1, trace2];

            let layout = {
                title: `Reads Counting Breakdown - ${runid !== undefined && runid !== null ? runid.split('_')[0] : runid} ${camera !== undefined && runid?.split('_')?.length === 2 ? camera : ''}`,
                barmode: 'stack',
                yaxis: {
                    title: '% of All Reads',
                },
            };

            let config = {
                modeBarButtonsToRemove: ['sendDataToCloud', 'displaylogo', 'pan2d', 'pan3d', 'autoScale2d', 'resetScale2d'],
                displaylogo: false,
                displayModeBar: true
            };

            return { data: data, layout: layout, config: config };
        }
        else {
            const USABLE_READS_PERC_LIMIT = 0.1;

            const filteredEntries = Object.entries(csv).filter(([key, value]) => {
                // Return true for entries to keep, false for entries to filter out
                return key !== 'none' && key !== 'TT' && key !== 'UNKN' && key !== 'UT';
            });

            const newObject = Object.fromEntries(filteredEntries);

            const filtered = Object.entries(newObject).filter(([key, value]) => {
                return value?.usable_reads > USABLE_READS_PERC_LIMIT;
            }).sort((a, b) => {
                return b[1]?.usable_reads - a[1]?.usable_reads;
            });

            let filteredObject = {};
            if (filtered.length > 20) {
                let items = Object.entries(newObject).filter(([key, value]) => {
                    return value?.usable_reads > USABLE_READS_PERC_LIMIT;
                });
                let others = ['Other > 0.1%', {
                    failed_RSQ: items.map(([key, value]) => value.failed_RSQ).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    failed_trimmer: items.map(([key, value]) => value.failed_trimmer).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    total_read_count: items.map(([key, value]) => value.total_read_count).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    usable_reads: items.map(([key, value]) => value.usable_reads).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                }];                

                let allOtherItems = Object.entries(newObject).filter(([key, value]) => {
                    return !filtered.slice(0, 20).map(([barcode, value]) => barcode).includes(key);
                }).filter(([key, value]) => {
                    return value?.usable_reads < USABLE_READS_PERC_LIMIT;
                });
                let othersAll = ['Other < 0.1%', {
                    failed_RSQ: allOtherItems.map(([key, value]) => value.failed_RSQ).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    failed_trimmer: allOtherItems.map(([key, value]) => value.failed_trimmer).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    total_read_count: allOtherItems.map(([key, value]) => value.total_read_count).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    usable_reads: allOtherItems.map(([key, value]) => value.usable_reads).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                }];
                let sliced = filtered.slice(0, 20);
                sliced.push(others);
                sliced.push(othersAll);

                filteredObject = Object.fromEntries(sliced);
            }
            else if (filtered.length < 20) {
                let items = Object.entries(newObject).filter(([key, value]) => {
                    return value?.usable_reads < USABLE_READS_PERC_LIMIT;
                });
                let others = ['Other < 0.1%', {
                    failed_RSQ: items.map(([key, value]) => value.failed_RSQ).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    failed_trimmer: items.map(([key, value]) => value.failed_trimmer).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    total_read_count: items.map(([key, value]) => value.total_read_count).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    usable_reads: items.map(([key, value]) => value.usable_reads).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                }];
                filtered.push(others);
                filteredObject = Object.fromEntries(filtered);
            }

            let trace1 = {
                x: Object.entries(filteredObject).map(([key, value]) => {
                    if (parseFloat(value?.usable_reads) > USABLE_READS_PERC_LIMIT) return key;
                }).filter(f => f !== undefined),
                y: Object.entries(filteredObject).map(([key, value]) => {
                    if (parseFloat(value?.usable_reads) > USABLE_READS_PERC_LIMIT) return value?.failed_trimmer.toFixed(2);
                }).filter(f => f !== undefined),
                name: 'Failed trimmer filters',
                type: 'bar',
                text: Object.entries(filteredObject).map(([key, value]) => {
                    if (parseFloat(value?.usable_reads) > USABLE_READS_PERC_LIMIT) return value?.failed_trimmer.toFixed(2);
                }).filter(f => f !== undefined).map(m => `${m}%`).map(String),
                textposition: 'auto',
                marker: { color: 'dimgrey' }
            };

            let trace2 = {
                x: Object.entries(filteredObject).map(([key, value]) => {
                    if (parseFloat(value?.usable_reads) > USABLE_READS_PERC_LIMIT) return key;
                }).filter(f => f !== undefined),
                y: Object.entries(filteredObject).map(([key, value]) => {
                    if (parseFloat(value?.usable_reads) > USABLE_READS_PERC_LIMIT) return value?.failed_RSQ.toFixed(2);
                }).filter(f => f !== undefined),
                name: 'Failed RSQ filter',
                type: 'bar',
                text: Object.entries(filteredObject).map(([key, value]) => {
                    if (parseFloat(value?.usable_reads) > USABLE_READS_PERC_LIMIT) return value?.failed_RSQ.toFixed(2);
                }).filter(f => f !== undefined).map(m => `${m}%`).map(String),
                textposition: 'auto',
                marker: { color: 'brown' }
            };

            let trace3 = {
                x: Object.entries(filteredObject).map(([key, value]) => {
                    if (parseFloat(value?.usable_reads) > USABLE_READS_PERC_LIMIT) return key;
                }).filter(f => f !== undefined),
                y: Object.entries(filteredObject).map(([key, value]) => {
                    if (parseFloat(value?.usable_reads) > USABLE_READS_PERC_LIMIT) return value?.usable_reads.toFixed(2);
                }).filter(f => f !== undefined),
                name: 'Usable reads',
                type: 'bar',
                text: Object.entries(filteredObject).map(([key, value]) => {
                    if (parseFloat(value?.usable_reads) > USABLE_READS_PERC_LIMIT) return value?.usable_reads.toFixed(2);
                }).filter(f => f !== undefined).map(m => `${m}%`).map(String),
                textposition: 'auto',
                marker: { color: 'blue' }
            };

            const data = [trace1, trace2, trace3];

            let layout = {
                title: `Reads Counting Breakdown - ${runid !== undefined && runid !== null ? runid.split('_')[0] : runid} ${camera !== undefined && runid?.split('_')?.length === 2 ? camera : ''}`,
                barmode: 'stack',
                yaxis: {
                    title: '% of All Reads',
                    //tickformat: ",.0%",
                    //range: [0, 100]
                },
                xaxis: {
                    title: 'Read Group',
                },
            };

            let config = {
                modeBarButtonsToRemove: ['sendDataToCloud', 'displaylogo', 'pan2d', 'pan3d', 'autoScale2d', 'resetScale2d'],
                displaylogo: false,
                displayModeBar: true
            };

            return { data: data, layout: layout, config: config };
        }
    }
    catch (e) {
        console.log(e);
        return undefined;
    }
}

export default RenderReadsFilteringCharts;